import React, { useState, useEffect } from "react";

import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Chart from "react-apexcharts";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import api from '../../../../../../core/services/api';
import options from "./options";

export default function ({ subtitle }) {
  const [state, setState] = useState({
    cols: [],
    clamps: [],
    forks: [],
    endDate: moment(Date.now()).format("YYYY-MM-DD"),
    startDate: moment(Date.now()).subtract(5, "d").format("YYYY-MM-DD"),
    operations: [],
    forklifts: [],
    forkliftID: null,
    operationID: null,
    loading: true,
    resultBy: 'day',
    dateRangeID: null,
    dateRange: [
      { id: 1, name: "Últimos 7 dias" },
      { id: 2, name: "Últimos 14 dias" },
      { id: 3, name: "Últimos 20 dias" },
      { id: 4, name: "Últimos 30 dias" },
      { id: 5, name: "Hoje" },
      { id: 6, name: "Ontem" },
      { id: 7, name: "Essa Semana" },
      { id: 8, name: "Última Semana" },
      { id: 9, name: "Esse Mês" },
      { id: 10, name: "Último Mês" },
      { id: 11, name: "Este Ano" },
    ],
  });

  function resetForklift() {
    setState(prev => ({
      ...prev,
      forkliftID: null
    }))
  }

  async function getData() {
    const config = await api.get('/settings');
    let url = `/forklift-idleness-by-type?start=${state.startDate}&end=${state.endDate}`;
    url += state.forkliftID ? "&forklift_number=" + state.forkliftID : "";
    url += state.operationID ? "&operation_place_id=" + state.operationID : "";
    url += state.resultBy ? "&result_by=" + state.resultBy : "day";

    const { data } = await api.get(url);

    const apiCols = [];
    const apiFork = [];
    const apiClamp = [];
    const apiValues2 = [];

    data.data.map(({ localdate, garfo, clamp }) => {
      if (state.resultBy == 'day') {
        apiCols.push(localdate);
      } else {
        apiCols.push(localdate);
      }
      apiFork.push(garfo || 0);
      apiClamp.push(clamp || 0);
      apiValues2.push(parseInt(config.data.resource.idleness_goals));
    });

    setState((prev) => ({
      ...prev,
      cols: apiCols,
      clamps: apiClamp,
      forks: apiFork,
      values2: apiValues2,
      loading: false,
    }));
  }

  async function initData() {
    const forklifts = await api.get("/forklifts");
    const operations = await api.get("/operation-places");
    setState((prev) => ({
      ...prev,
      forklifts: forklifts.data,
      operations: operations.data,
    }));
  }

  // Handle data and changes
  useEffect(() => {
    getData();
  }, [state.startDate, state.endDate, state.forkliftID]);

  // Handle data and changes
  useEffect(() => {
    resetForklift();
    getData();
  }, [state.operationID]);

  // First Loading Use Effect
  useEffect(() => {
    initData();
  }, []);

  const handleStartDate = (date) => {
    setState((prev) => ({
      ...prev,
      startDate: moment(date).format("YYYY-MM-DD"),
    }));
  };

  const handleEndDate = (date) => {
    setState((prev) => ({
      ...prev,
      endDate: moment(date).format("YYYY-MM-DD"),
    }));
  };

  const changeOperationID = (e) => {
    const { value } = e.target;
    setState((prev) => ({
      ...prev,
      operationID: value,
      forkliftID: null
    }));
  };

  const changeForkliftID = (e) => {
    const { value } = e.target;
    setState((prev) => ({
      ...prev,
      forkliftID: value,
    }));
  };

  const changeDateRange = (e) => {
    const { value } = e.target;
    if (value == 1) {
      setState((prev) => ({
        ...prev,
        startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        resultBy: 'day'
      }));
    }
    if (value == 2) {
      setState((prev) => ({
        ...prev,
        startDate: moment().subtract(14, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        resultBy: 'day'
      }));
    }
    if (value == 3) {
      setState((prev) => ({
        ...prev,
        startDate: moment().subtract(20, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        resultBy: 'day'
      }));
    }
    if (value == 4) {
      setState((prev) => ({
        ...prev,
        startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        resultBy: 'day'
      }));
    }
    if (value == 5) {
      setState((prev) => ({
        ...prev,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        resultBy: 'day'
      }));
    }
    if (value == 6) {
      setState((prev) => ({
        ...prev,
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        resultBy: 'day'
      }));
    }
    if (value == 7) {
      setState((prev) => ({
        ...prev,
        startDate: moment().startOf("isoWeek").format("YYYY-MM-DD"),
        endDate: moment().endOf("isoWeek").format("YYYY-MM-DD"),
        resultBy: 'day'
      }));
    }
    if (value == 8) {
      const firsDayWeek = moment().startOf("isoWeek");
      const lastWeek = firsDayWeek.subtract(1, "days");
      setState((prev) => ({
        ...prev,
        startDate: lastWeek.startOf("isoWeek").format("YYYY-MM-DD"),
        endDate: lastWeek.endOf("isoWeek").format("YYYY-MM-DD"),
        resultBy: 'day'
      }));
    }
    if (value == 9) {
      setState((prev) => ({
        ...prev,
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().endOf("month").format("YYYY-MM-DD"),
        resultBy: 'day'
      }));
    }
    if (value == 10) {
      const firstDayMonth = moment().startOf("month");
      const lastMonth = firstDayMonth.subtract(1, "days");
      setState((prev) => ({
        ...prev,
        startDate: lastMonth.startOf("month").format("YYYY-MM-DD"),
        endDate: lastMonth.endOf("month").format("YYYY-MM-DD"),
        resultBy: 'day'
      }));
    }
    if (value == 11) {
      setState((prev) => ({
        ...prev,
        startDate: moment().startOf("year").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        resultBy: 'month'
      }));
    }
  };
  return (
    <Paper>
      <Container>
        <h5
          style={{ color: "grey", textAlign: "center", fontWeight: "bolder" }}
        >
          Ociosidade Máquina Empilhadeira - {subtitle}
        </h5>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            flex: 1,
            marginTop: "30px",
          }}
        >
          <Select
            displayEmpty
            value={state.operationID}
            onChange={changeOperationID}
            style={{ width: "223px", height: "48px" }}
            placeholder="Empilhadeiras"
          >
            <MenuItem key="all" value={null}>
              Operações
            </MenuItem>
            {state.operations.length > 0 &&
              state.operations.map(({ id, name }) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
          </Select>
          <Select
            displayEmpty
            value={state.forkliftID}
            onChange={changeForkliftID}
            style={{ width: "223px", height: "48px" }}
            placeholder="Empilhadeiras"
          >
            <MenuItem key="all" value={null}>
              Empilhadeiras
            </MenuItem>
            {state.forklifts.length > 0 &&
              state.forklifts
                .filter((item) => {
                  if (!state.operationID) return true;
                  if (state.operationID == item.operation_place_id) return true;
                })
                .map(({ id, forklift_number }) => (
                  <MenuItem key={id} value={forklift_number}>
                    {forklift_number}
                  </MenuItem>
                ))}
          </Select>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="dd/MM/yyyy"
              label="Data Inicial"
              value={moment(state.startDate, "YYYY-MM-DD")}
              onChange={handleStartDate}
              KeyboardButtonProps={{
                "aria-label": "state Inicial",
              }}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="dd/MM/yyyy"
              label="Data Final"
              value={moment(state.endDate, "YYYY-MM-DD")}
              onChange={handleEndDate}
              KeyboardButtonProps={{
                "aria-label": "Data Inicial",
              }}
            />
          </MuiPickersUtilsProvider>
          <Select
            displayEmpty
            value={state.dateRangeID}
            onChange={changeDateRange}
            style={{ width: "223px", height: "48px" }}
            placeholder="Período"
          >
            <MenuItem key="all" value={null}>
              Período
            </MenuItem>
            {state.dateRange.length > 0 &&
              state.dateRange.map(({ id, name }) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
          </Select>
        </div>
        <div style={{ padding: "30px 0", minHeight: "300px" }}>
          {!state.loading && (
            <Chart
              options={options(state.cols, state.values2[0])}
              series={[
                { name: "Garfo", data: state.forks },
                { name: "Clamp", data: state.clamps },
              ]}
              type="bar"
              height={350}
            />
          )}
          
        </div>
      </Container>
    </Paper>
  );
}
